import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import cloudImage from '../resources/images/cloud.png';
export default function CompleteVerification(props) {
    return (React.createElement(Stack, { spacing: 1, direction: 'row', sx: {
            borderRadius: '24px',
            border: '1px solid #5124A6',
            padding: '5px',
            alignItems: 'center',
            cursor: 'pointer',
        } },
        React.createElement("img", { src: cloudImage, height: '18px', width: '18px', alt: "pending" }),
        React.createElement(Typography, { color: '#5124A6', fontWeight: '700', fontSize: '12px', pr: '4px', display: { xs: 'none', md: 'flex' } }, props.title)));
}
//# sourceMappingURL=CompleteVerification.js.map